import React from "react";
import PropTypes from "prop-types";

const FailedWarning = ({ failReason }) => {
  return (
    <div className="varsome-text-center">
      <i className="fa fa-exclamation-circle varsome-text-muted tw-mr-1" />
      {failReason}
    </div>
  );
};

FailedWarning.propTypes = {
  failReason: PropTypes.string,
};

FailedWarning.defaultProps = {
  failReason: null,
};
export default React.memo(FailedWarning);
